import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './styles.css'; 
import logo from '../../../..//src/assets/images/logo.jpeg'
import * as mui from '@mui/material';
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import AuthService from '../../../services/AuthService';

// Custom styled tooltip
const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: '#333',
    color: '#fff',
    fontSize: 12,
    padding: '6px 12px',
    borderRadius: 4,
    marginLeft: 5,
    borderLeft: '3px solid #0288d1',
    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
    zIndex: 9999, // Ensure tooltip is above all elements
  },
  [`& .MuiTooltip-arrow`]: {
    color: '#333',
  },
  // Make sure the popper receives events
  pointerEvents: 'auto',
}));

// Styled list item to fix issues with tooltips on li elements
const StyledListItem = styled('li')({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  height: '48px',
  width: '100%',
});

// Convert class component to functional component
const IASideBar = ({ mainContent }) => {
    const [drawerPos, setDrawerPos] = useState(1);
    const [currentProjectId, setCurrentProjectId] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        // Get most recent project ID from localStorage
        try {
            const recentProjects = JSON.parse(localStorage.getItem('recentAuditProjects')) || [];
            if (recentProjects.length > 0) {
                const mostRecentProject = recentProjects[0];
                setCurrentProjectId(mostRecentProject.id);
            }
        } catch (error) {
            console.error('Error retrieving recent projects:', error);
        }
    }, []);

    const handleDrawer = () => {
        if (drawerPos < 2) {
            setDrawerPos(drawerPos + 1);
        } else {
            setDrawerPos(0);
        }
    };

    const handleLogout = async () => {
        try {
            // AuthService.logout handles both server-side and client-side logout
            await AuthService.logout();
            
            // Note: AuthService.logout already redirects to /loginform
            // But we can override to navigate to /login if needed
            navigate('/login');
        } catch (error) {
            console.error('Error during logout:', error);
            navigate('/login');
        }
    };

    // Add navigation handlers
    const handleDashboard = () => {
        navigate('/audit/projects');
    };

    const handleWorkpapers = () => {
        if (currentProjectId) {
            navigate(`/audit/workpapers/${currentProjectId}`);
        } else {
            // If no project ID is available, show a message or redirect to projects page
            alert('Please select a project first');
            navigate('/audit/projects');
        }
    };

    const handleControls = () => {
        navigate('/audit/controlslibrary');
    };

    const handleRisk = () => {
        navigate('/audit/risklibrary');
    };

    const handleWalkthroughs = () => {
        if (currentProjectId) {
            navigate(`/audit/riskandcontrolmapping/${currentProjectId}`);
        } else {
            // If no project ID is available, show a message or redirect to projects page
            alert('Please select a project first');
            navigate('/audit/projects');
        }
    };

    const handleDocumentRequests = () => {
        if (currentProjectId) {
            navigate(`/audit/auditrequests/${currentProjectId}`);
        } else {
            // If no project ID is available, show a message or redirect to projects page
            alert('Please select a project first');
            navigate('/audit/projects');
        }
    };

    const handleDeficiencies = () => {
        navigate('/deficiencies');
    };

    const handleSettings = () => {
        if (currentProjectId) {
            navigate(`/audit/manageaccess/${currentProjectId}`);
        } else {
            // If no project ID is available, show a message or redirect to projects page
            alert('Please select a project first');
            navigate('/audit/projects');
        }
    };

    let drawerClass = [];
    let mainClass = [];

    if (drawerPos === 1) {
        drawerClass.push('drawerMin');
        mainClass.push('mainMin');
    } else if (drawerPos === 2) {
        drawerClass.push('drawerOpen');
        mainClass.push('mainOpen');
    } else {
        drawerClass = [];
        mainClass = [];
    }

    // Check if drawer is currently minimized (for tooltips)
    const isDrawerMinimized = drawerPos === 1;

    return (
        <div className="App">
            <navbar>
                <i className="material-icons" onClick={handleDrawer}>
                    menu
                </i>
            
                <a className="navbar-brand" href="/" style={{ marginLeft: '10px' }}>
                    <img src={logo} width="35" height="35" className="d-inline-block align-top" alt="" />
                    <span className="menu-collapsed" style={{ marginLeft: '10px', fontSize: '25px', color: 'white' }}>Audit-AI</span>
                </a>
            </navbar>
            <aside className={drawerClass.join(' ')}>
                <ul>
                    {isDrawerMinimized ? (
                        // For minimized drawer, show tooltips
                        <>
                            <StyledTooltip title="Audit Projects" placement="right" arrow>
                                <StyledListItem onClick={handleDashboard} className="sidebar-item">
                                    <i className="material-icons">dashboard</i>
                                    <span>Audit Projects</span>
                                </StyledListItem>
                            </StyledTooltip>
                            <StyledTooltip title="Workpapers" placement="right" arrow>
                                <StyledListItem onClick={handleWorkpapers} className="sidebar-item">
                                    <i className="material-icons">folder_special</i>
                                    <span>Workpapers</span>
                                </StyledListItem>
                            </StyledTooltip>
                            <StyledTooltip title="Controls" placement="right" arrow>
                                <StyledListItem onClick={handleControls} className="sidebar-item">
                                    <i className="material-icons">verified_user</i>
                                    <span>Controls</span>
                                </StyledListItem>
                            </StyledTooltip>
                            <StyledTooltip title="Risk" placement="right" arrow>
                                <StyledListItem onClick={handleRisk} className="sidebar-item">
                                    <i className="material-icons">bug_report</i>
                                    <span>Risk</span>
                                </StyledListItem>
                            </StyledTooltip>
                            <StyledTooltip title="Risk and Controls" placement="right" arrow>
                                <StyledListItem onClick={handleWalkthroughs} className="sidebar-item">
                                    <i className="material-icons">rebase_edit</i>
                                    <span>Risk and Controls</span>
                                </StyledListItem>
                            </StyledTooltip>
                            <StyledTooltip title="Document Requests" placement="right" arrow>
                                <StyledListItem onClick={handleDocumentRequests} className="sidebar-item">
                                    <i className="material-icons">pending_actions</i>
                                    <span>Document Requests</span>
                                </StyledListItem>
                            </StyledTooltip>
                           
                            <StyledTooltip title="Settings" placement="right" arrow>
                                <StyledListItem onClick={handleSettings} className="sidebar-item">
                                    <i className="material-icons">tune</i>
                                    <span>Settings</span>
                                </StyledListItem>
                            </StyledTooltip>
                            <StyledTooltip title="Logout" placement="right" arrow>
                                <StyledListItem onClick={handleLogout} className="sidebar-item">
                                    <i className="material-icons">logout</i>
                                    <span>Logout</span>
                                </StyledListItem>
                            </StyledTooltip>
                        </>
                    ) : (
                        // For expanded drawer, no tooltips needed
                        <>
                            <StyledListItem onClick={handleDashboard} className="sidebar-item">
                                <i className="material-icons">dashboard</i>
                                <span>Audit Projects</span>
                            </StyledListItem>
                            <StyledListItem onClick={handleWorkpapers} className="sidebar-item">
                                <i className="material-icons">folder_special</i>
                                <span>Workpapers</span>
                            </StyledListItem>
                            <StyledListItem onClick={handleControls} className="sidebar-item">
                                <i className="material-icons">verified_user</i>
                                <span>Controls</span>
                            </StyledListItem>
                            <StyledListItem onClick={handleRisk} className="sidebar-item">
                                <i className="material-icons">bug_report</i>
                                <span>Risk</span>
                            </StyledListItem>
                            <StyledListItem onClick={handleWalkthroughs} className="sidebar-item">
                                <i className="material-icons">rebase_edit</i>
                                <span>Risk and Controls</span>
                            </StyledListItem>
                            <StyledListItem onClick={handleDocumentRequests} className="sidebar-item">
                                <i className="material-icons">pending_actions</i>
                                <span>Document Requests</span>
                            </StyledListItem>
                            <StyledListItem onClick={handleDeficiencies} className="sidebar-item">
                                <i className="material-icons">warning</i>
                                <span>Deficiencies</span>
                            </StyledListItem>
                            <StyledListItem onClick={handleSettings} className="sidebar-item">
                                <i className="material-icons">tune</i>
                                <span>Settings</span>
                            </StyledListItem>
                            <StyledListItem onClick={handleLogout} className="sidebar-item">
                                <i className="material-icons">logout</i>
                                <span>Logout</span>
                            </StyledListItem>
                        </>
                    )}
                </ul>
            </aside>

        <main className={mainClass.join(' ')}>
          {mainContent}
        </main>

        </div>
    );
};

export default IASideBar;
